module.exports = __webpack_public_path__ + "img/Soil System Map.c3bdeaec.jpg";